import gql from 'graphql-tag';
import { RelatedArticlesSectionFragment } from './blog-education-center';

export const PrivateCreditRelatedArticlesQuery = gql`
	query PrivateCreditMarketingPage {
		allPrivateCreditLandingPage {
			investorUpdatesSection: relatedArticles {
				...RelatedArticlesSectionFragment
			}
		}
	}
	${RelatedArticlesSectionFragment}
`;
